const platforms = [
  {
    id: 'ulapp',
    name: 'U Llifestyle APP',
  },
  {
    id: 'hk',
    name: '港生活',
  },
  {
    id: 'beauty',
    name: 'U Beauty',
  },
  {
    id: 'travel',
    name: 'U Travel',
  },
  {
    id: 'food',
    name: 'U Food',
  },
  {
    id: 'blog',
    name: 'U Blog',
  },
  {
    id: 'skypost',
    name: '晴報',
  },
];
export default platforms;
